export async function decryptData(encryptedBase64: string, secretKey: any) {
  // Base64 디코딩
  const encryptedData = new Uint8Array(
    atob(encryptedBase64)
      .split("")
      .map((char) => char.charCodeAt(0))
  );

  // IV 추출 (첫 12바이트)
  const iv = encryptedData.slice(0, 12);
  const data = encryptedData.slice(12);

  // 비밀키를 CryptoKey로 가져오기
  const key = await window.crypto.subtle.importKey(
    "raw",
    secretKey,
    { name: "AES-GCM", length: 256 },
    false,
    ["encrypt", "decrypt"]
  );

  // 복호화 수행
  const decryptedContent = await window.crypto.subtle.decrypt(
    {
      name: "AES-GCM",
      iv: iv,
    },
    key,
    data
  );

  // 복호화된 데이터를 문자열로 변환
  const decoder = new TextDecoder();
  const decryptedString = decoder.decode(decryptedContent);

  // JSON으로 파싱
  return JSON.parse(decryptedString);
}

export const secretKey = new Uint8Array([
  1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22,
  23, 24, 25, 26, 27, 28, 29, 30, 31, 32,
]);
